import React from 'react';
import { credentials } from '../data/content';
export function CredentialBadges() {
  return <ul className="grid grid-cols-4 divide-x divide-white/15" aria-label="Professional credentials" data-id="element-36" data-mp="dkzd924tc5me">
      {credentials.map(c => <li key={c.abbr} className="px-3 text-center first:pl-0 last:pr-0 sm:px-4" data-id="element-37" data-mp="icpuzt62xvnu">
          <span className="block font-serif text-lg font-semibold text-gold sm:text-xl" data-id="element-38" data-mp="na9aeweikehd">{c.abbr}</span>
          <span className="mt-1 block text-[10px] font-medium uppercase tracking-[0.12em] text-white/70" data-id="element-39" data-mp="3lu80htydqql3">
            {c.short}
          </span>
        </li>)}
    </ul>;
}